import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Flex, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { hideModal } from '../../redux/modules/modal';
import StackedButtonGroup from '../Modal/ModalButtonGroups/StackedButtonGroup';

function DeleteModalBody({
  cancelOnClick,
  dataAnalyticsId,
  deleteMessage,
  itemsToDelete,
  itemIdKey,
  itemLabelKey,
  primaryButtonLabel,
  primaryOnClick,
  secondaryButtonLabel
}) {
  const dispatch = useDispatch();

  const onSubmit = () => {
    primaryOnClick?.();
  };

  const onCancel = () => {
    cancelOnClick?.();
    dispatch(hideModal());
  };

  return (
    <Box>

      <Box mb={4} mt={2}>
        <Text>{deleteMessage}</Text>
      </Box>

      { !!itemsToDelete.length && (
        <Box mb={6}>
          {itemsToDelete.map(item => (
            <Box
              bgColor="greyScale.200"
              borderRadius="md"
              key={item[itemIdKey]}
              p={4}
            >
              <Text textStyle="bodyMd500">{item[itemLabelKey]}</Text>
            </Box>
          ))}
        </Box>
      )}

      <StackedButtonGroup
        dataAnalyticsId={dataAnalyticsId}
        label={primaryButtonLabel}
        primaryButtonVariant="gradientError"
        secondaryClick={onCancel}
        secondaryLabel={secondaryButtonLabel}
        onClick={onSubmit}
      />
    </Box>
  );
}

DeleteModalBody.propTypes = {
  dataAnalyticsId: PropTypes.string,
  deleteMessage: PropTypes.string,
  cancelOnClick: PropTypes.func,
  itemsToDelete: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })),
  itemIdKey: PropTypes.string,
  itemLabelKey: PropTypes.string,
  primaryButtonLabel: PropTypes.string,
  primaryOnClick: PropTypes.func,
  secondaryButtonLabel: PropTypes.string
};

DeleteModalBody.defaultProps = {
  dataAnalyticsId: undefined,
  deleteMessage: 'Are you sure you want to delete this?',
  itemsToDelete: [],
  itemIdKey: 'id',
  itemLabelKey: 'name',
  primaryButtonLabel: 'Delete',
  secondaryButtonLabel: 'Cancel'
};

export default DeleteModalBody;
